import { createStyles, Box } from "@mantine/core";

import AddButton from "../../../components/AddButton";
import ReportModal from "../../../components/ReportModal";
import ReportTable from "../../../components/ReportTable";
import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { getReports } from "../../../services/report";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import { useSelector } from "react-redux";
import { getAllNoteTypes } from "../../../services/note";
import { getAllStaff } from "../../../services/staff";
import { getAllFacilitiesModal, getAllFacilityTypes } from "../../../services";
import { getAllPatients, getAllPatientsModal } from "../../../services/patient";
import { getTaskTypes } from "../../../services/task";
import { TrackPageView } from "../../../config/mixpanelConfig";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { getAllSignatures } from "../../../services/signature";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "auto",
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
    display: "flex",
    justifyContent: "flex-end",
  },
  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  pagination: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
}));
const Reports = (props) => {

  const { reports } = useSelector((state) => state.report);
  const { patients } = useSelector((state) => state.patient);
  const [currentPage, setCurrentPage] = useState(1);
  const { profile } = useSelector((state) => state?.profile);

  useEffect(() => {
    getReports(currentPage);
  }, [currentPage]);

  useEffect(() => {
    TrackPageView("Report");
    getAllSignatures();
  }, []);

  // get all data to populate all related fields in the reports
  useEffect(() => {
    getAllNoteTypes();
    getTaskTypes();
    getAllStaff("withDeleted");
    getAllFacilitiesModal("withDeleted");
    getAllFacilityTypes();
    getAllPatientsModal("withDeleted");
    getAllPatients("withDeleted");
  }, []);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const { classes } = useStyles();
  const [opened, { open, close }] = useDisclosure(false);
  return (
    <Box className={classes.content}>
      <AppNavbar title={"Reports"} profile={profile} />
      <ReportModal
        opened={opened}
        onclose={close}
        title={"Add New Report"}
      />
      <Box px={20}>
        <Box className={classes.btn}>
          <AddButton
            title={"Add New Report"}
            onClick={open}
            disabled={patients?.patients?.length > 0 ? false : true}
          />
        </Box>
        <ReportTable />
        <CustomPagination
          data={reports?.count}
          itemsPerPage={10}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      </Box>
    </Box>
  );
};

export default Reports;
